import {
  GetProtocolVersionsResponse,
  IAIReviewJobResultDocsListItem,
  IAIReviewJobResultDocsListPayload,
  IAIReviewJobResultDocsListResponse,
  IAIReviewJobResultIssueCodeResponse,
  ProtocolDetailsResponse,
  ProtocolVersionsResponse,
} from '../types/aiReview.type';
import type {ProtocolVersionDetailsResponseV2} from '../types/aiReview.type';

/** V2 mock list — used until protocol-intelligence/list returns the new contract. */
export const mockProtocolListData: ProtocolVersionsResponse = {
  totalRecords: 10,
  protocolVersions: [
    {
      protocolId: 1,
      createdBy: 'Khairnar, Sachin',
      lastUpdatedAt: '2026-06-08T10:07:08.313Z',
      isActive: 1,
      isApproved: true,
      isUploaded: true,
      protocolName: 'review protocol v1',
      latestVersion: 'v8',
      versionId: 1,
      status: 'Approved',
      source: 'review protocol v1',
    },
    {
      protocolId: 2,
      createdBy: 'Patel, Anita',
      lastUpdatedAt: '2026-06-09T14:22:11.000Z',
      isActive: 0,
      isApproved: true,
      isUploaded: false,
      protocolName: 'employment discrimination protocol',
      latestVersion: 'v3',
      versionId: 2,
      status: 'Approved',
      source: 'Manual',
    },
    {
      protocolId: 3,
      createdBy: 'Smith, John',
      lastUpdatedAt: '2026-06-10T08:15:40.000Z',
      isActive: 1,
      isApproved: false,
      isUploaded: true,
      protocolName: 'contract review protocol',
      latestVersion: 'v1',
      versionId: 3,
      status: 'Draft',
      source: 'Manual',
    },
    {
      protocolId: 4,
      createdBy: 'Khairnar, Sachin',
      lastUpdatedAt: '2026-06-11T16:45:00.000Z',
      isActive: 1,
      isApproved: true,
      isUploaded: true,
      protocolName: 'ip litigation protocol',
      latestVersion: 'v6',
      versionId: 4,
      status: 'Approved',
      source: 'ip litigation protocol',
    },
    {
      protocolId: 5,
      createdBy: 'Garcia, Maria',
      lastUpdatedAt: '2026-06-12T09:30:22.000Z',
      isActive: 0,
      isApproved: false,
      isUploaded: false,
      protocolName: 'merger communications protocol',
      latestVersion: 'v2',
      versionId: 5,
      status: 'Draft',
      source: 'Manual',
    },
    {
      protocolId: 6,
      createdBy: 'Patel, Anita',
      lastUpdatedAt: '2026-06-13T11:05:18.000Z',
      isActive: 1,
      isApproved: true,
      isUploaded: true,
      protocolName: 'negligence case protocol',
      latestVersion: 'v4',
      versionId: 6,
      status: 'Approved',
      source: 'negligence case protocol',
    },
    {
      protocolId: 7,
      createdBy: 'Chen, Wei',
      lastUpdatedAt: '2026-06-14T13:40:55.000Z',
      isActive: 0,
      isApproved: false,
      isUploaded: true,
      protocolName: 'financial damages protocol',
      latestVersion: 'v1',
      versionId: 7,
      status: 'Draft',
      source: 'Manual',
    },
    {
      protocolId: 8,
      createdBy: 'Smith, John',
      lastUpdatedAt: '2026-06-15T07:12:33.000Z',
      isActive: 1,
      isApproved: true,
      isUploaded: false,
      protocolName: 'age discrimination protocol',
      latestVersion: 'v5',
      versionId: 8,
      status: 'Approved',
      source: 'age discrimination protocol',
    },
    {
      protocolId: 9,
      createdBy: 'Garcia, Maria',
      lastUpdatedAt: '2026-06-16T18:20:09.000Z',
      isActive: 0,
      isApproved: false,
      isUploaded: true,
      protocolName: 'wrongful termination protocol',
      latestVersion: 'v2',
      versionId: 9,
      status: 'Draft',
      source: 'Manual',
    },
    {
      protocolId: 10,
      createdBy: 'Chen, Wei',
      lastUpdatedAt: '2026-06-17T12:55:47.000Z',
      isActive: 1,
      isApproved: true,
      isUploaded: true,
      protocolName: 'breach of contract protocol',
      latestVersion: 'v7',
      versionId: 10,
      status: 'Approved',
      source: 'breach of contract protocol',
    },
  ],
};

export const mockProtocolDetailsData: ProtocolDetailsResponse = {
  protocolId: 3,
  aIstatus: 'Pending', //other status would be completed ,
  caseContext:
    'Employment discrimination case involving wrongful termination of senior engineer Jane Doe on grounds of age discrimination. Claims include ADEA violations, breach of contract, and emotional distress.',
  relevanceCriteria:
    "Documents are relevant if they relate to: (1) Jane Doe's employment history, performance reviews, or disciplinary actions; (2) Company policies on termination or age-related employment matters; (3) Communications regarding the decision to terminate Jane Doe; (4) Evidence of discriminatory treatment based on age.",
  issueCodes: [
    {
      code: 'TERMINATION',
      question:
        'Does this document relate to the decision to terminate Jane Doe?',
    },
    {
      code: 'AGE_DISCRIMINATION',
      question:
        'Does this document contain evidence of age-based discrimination?',
    },
    {
      code: 'PERFORMANCE',
      question: "Does this document discuss Jane Doe's performance?",
    },
  ],
  createdAt: '2026-05-12T10:07:08.313Z',
  createdBy: 'khairnar, Sachin', //Lastname, Firstname
  isUploaded: true, //created/uploaded //based on save as or created at upload time - protocol version
  isActive: 1,
  protocolName: 'Filename.docx',
  isApproved: true, // true or false
  isSaved: false,
};

export const mockIssueCodeResponse: IAIReviewJobResultIssueCodeResponse = {
  issueCodeResults: [
    {
      reviewJobIssueCodeID: 1,
      reviewJobIssueCode: 'Breach of Contract',
      question: 'Does the document mention any breach of contract?',
      relevantCount: 142,
      nonRelevantCount: 58,
    },
    {
      reviewJobIssueCodeID: 2,
      reviewJobIssueCode: 'Negligence',
      question: 'Is there evidence of negligence by the defendant?',
      relevantCount: 87,
      nonRelevantCount: 113,
    },
    {
      reviewJobIssueCodeID: 3,
      reviewJobIssueCode: 'Financial Damages',
      question: 'Does the document reference any financial damages?',
      relevantCount: 210,
      nonRelevantCount: 30,
    },
    {
      reviewJobIssueCodeID: 4,
      reviewJobIssueCode: 'IP Violations',
      question: 'Is there any mention of intellectual property violations?',
      relevantCount: 45,
      nonRelevantCount: 195,
    },
    {
      reviewJobIssueCodeID: 5,
      reviewJobIssueCode: 'Merger Communications',
      question: 'Does the document contain communications about the merger?',
      relevantCount: 178,
      nonRelevantCount: 62,
    },
  ],
};

/**
 * In-memory delete state for mock protocol list (AVR-22091 BE not ready).
 * Protocol id 1 simulates "used by jobs" → 409 Conflict for UI testing.
 * TODO: remove once DELETE protocol-intelligence/{protocolId} is live (AVR-22091).
 */
const deletedMockProtocolIds = new Set<number>();
export const MOCK_PROTOCOL_IDS_IN_USE_BY_JOBS = new Set<number>([1]);

export const isMockProtocolDeleted = (protocolId: number): boolean =>
  deletedMockProtocolIds.has(protocolId);

export const resetMockProtocolDeleteState = (): void => {
  deletedMockProtocolIds.clear();
};

export const mockDeleteAIProtocolIntelligence = (
  protocolId: number
): {protocolId: number} => {
  if (MOCK_PROTOCOL_IDS_IN_USE_BY_JOBS.has(protocolId)) {
    const conflict = Object.assign(
      new Error('Protocol is used by one or more jobs and cannot be deleted'),
      {status: 409}
    );
    throw conflict;
  }

  deletedMockProtocolIds.add(protocolId);
  return {protocolId};
};

/**
 * V2 protocol version details mock — used when GET
 * protocol-intelligence/versions/{versionId} is unavailable.
 * Kept self-contained (no component imports) to avoid circular deps with aiReviewApi.
 */
export const getMockProtocolVersionDetailsV2 = (
  versionId: number
): ProtocolVersionDetailsResponseV2 => {
  const listMatch = mockProtocolListData.protocolVersions.find(
    (p) => p.versionId === versionId || p.protocolId === versionId
  );
  const status: ProtocolVersionDetailsResponseV2['status'] =
    listMatch?.status?.toLowerCase() === 'approved' ? 'approved' : 'draft';

  return {
    protocolName: listMatch?.protocolName ?? `Mock Protocol v${versionId}`,
    status,
    caseContext: {
      executive_summary:
        'This matter concerns alleged breaches of fiduciary duty and misappropriation of trade secrets by a former executive who joined a competitor.',
      parties_and_roles: [
        {
          party: 'Acme Technologies, Inc.',
          role: 'Plaintiff',
          party_description: 'Software company alleging misappropriation.',
        },
        {
          party: 'Jordan Hale',
          role: 'Defendant / Former VP Engineering',
          party_description: 'Former Acme executive who joined a competitor.',
        },
      ],
      claims: ['Misappropriation of trade secrets', 'Breach of fiduciary duty'],
      defenses: ['Independent development of competing product features'],
      disputed_facts: [
        'Whether customer pricing models qualify as trade secrets',
      ],
      key_legal_and_factual_issues: [
        'Ownership and protectability of product roadmap materials',
      ],
      primary_date_range: '2022-01-01 to 2024-03-31',
      important_subperiods: ['2023-01 to 2023-02: Resignation and transition'],
      custodians: ['Jordan Hale'],
      departments: ['Engineering', 'Sales', 'Legal'],
      systems_and_repositories: ['Microsoft 365', 'Slack', 'GitHub Enterprise'],
      responsiveness_standard_definition:
        'A document is responsive if it discusses confidential technical information, customer lists, or solicitation of key employees during the primary date range.',
      responsive_examples: [
        'Email attaching customer pricing spreadsheet to a personal account',
      ],
      non_responsive_examples: ['Routine HR benefits enrollment notices'],
      relevancy_keywords: ['trade secret', 'roadmap', 'customer list'],
      relevance_themes: ['Transfer of confidential technical materials'],
      behavioral_indicators: [
        'Large file downloads shortly before resignation',
      ],
      decision_making_indicators: [
        'Approvals to share roadmap decks externally',
      ],
      explicit_exclusions: [
        'Documents solely about publicly filed court pleadings',
      ],
      reviewer_instructions: [
        'Flag any attachment that appears to be a customer export',
      ],
      borderline_scenarios: [
        'Public conference slides that closely mirror internal roadmap wording',
      ],
      ambiguities_and_known_limits: [
        'Slack retention may be incomplete before mid-2022',
      ],
    },
    relevanceCriteria: {
      master_relevance_standard:
        'Documents are relevant when they discuss the claims, defenses, or disputed facts in the case context, within the primary date range.',
      exclusion_gates: [
        {
          id: 'EG-001',
          other: '',
          hard_rule: 'Exclude pure spam and automated system notifications.',
          tag: 'Spam',
        },
      ],
      primary_decision_questions: [
        {
          id: 'PDQ-001',
          question_text:
            'Does this document discuss employee misconduct or related investigation facts?',
          rationale: 'Primary relevance gate for investigation protocols.',
        },
      ],
      secondary_supporting_questions: [
        {
          id: 'SSQ-001',
          question_text:
            'Does the document reference related parties, custodians, or systems?',
          purpose: 'Supports primary relevance determination.',
        },
      ],
      negative_exclusion_questions: [
        {
          id: 'NEQ-001',
          question_text:
            'Is the document solely administrative with no case nexus?',
          purpose: 'Identify clear non-responsive material.',
        },
      ],
      escalation_triggers: [
        {
          id: 'ET-001',
          question_text:
            'Does the document appear to contain attorney-client privileged content?',
          purpose: 'Escalate for privilege review.',
        },
      ],
    },
    issueCoding: {
      top_level_issue_categories: [
        {
          category_id: 'CAT-001',
          category_label: 'Policy / Conduct',
          category_description:
            'Issues related to workplace policy and employee conduct.',
        },
      ],
      issue_codes: [
        {
          code_id: 'IC-001',
          code_name: 'Policy Violation',
          category: 'CAT-001',
          priority: 'Core',
          definition: 'Communications discussing breach of company policy.',
          include_if_any_apply: ['policy breach', 'code of conduct'],
          exclude_if_any_apply: ['holiday calendar'],
          responsive_examples: [
            'Email discussing policy violation',
            'Slack conversation confirming violation',
          ],
          non_responsive_examples: ['Holiday calendar'],
        },
      ],
      cross_issue_overlap_rules: [
        'Apply Policy Violation before Compliance if both apply.',
      ],
      edge_case_handling: [
        'If only metadata mentions a policy code with no body discussion, mark non-responsive.',
      ],
    },
    fileDetails: {
      fileName: listMatch?.isUploaded ? `${listMatch.protocolName}.pdf` : '',
      reviewProtocolDocumentID: listMatch?.isUploaded ? versionId : null,
    },
  };
};

/**
 * Mock for GET protocol-intelligence/{protocolId}/versions when BE is unavailable.
 */
export const getMockProtocolVersions = (
  _protocolId: number
): GetProtocolVersionsResponse => ({
  versions: [
    {versionId: 1, name: 'v2', status: 'draft'},
    {versionId: 2, name: 'v1', status: 'approved'},
  ],
});

/** Seed rows for POST …/issuecoding/doc-result/view-by-docs (AVR-21305). */
export const mockViewByDocsRows: IAIReviewJobResultDocsListItem[] = [
  {
    documentId: 101,
    reviewJobSubmittedId: 501,
    docId: 10001,
    issueCodeMatchedCount: 5,
    flag: '',
  },
  {
    documentId: 102,
    reviewJobSubmittedId: 501,
    docId: 10002,
    issueCodeMatchedCount: 3,
    flag: 'Priority',
  },
  {
    documentId: 103,
    reviewJobSubmittedId: 502,
    docId: 10003,
    issueCodeMatchedCount: 0,
    flag: '',
  },
  {
    documentId: 104,
    reviewJobSubmittedId: 502,
    docId: 10004,
    issueCodeMatchedCount: 12,
    flag: 'Hot',
  },
  {
    documentId: 105,
    reviewJobSubmittedId: 503,
    docId: 10005,
    issueCodeMatchedCount: 1,
    flag: '',
  },
  {
    documentId: 106,
    reviewJobSubmittedId: 503,
    docId: 10006,
    issueCodeMatchedCount: 8,
    flag: 'Review',
  },
  {
    documentId: 107,
    reviewJobSubmittedId: 504,
    docId: 10007,
    issueCodeMatchedCount: 2,
    flag: '',
  },
  {
    documentId: 108,
    reviewJobSubmittedId: 504,
    docId: 10008,
    issueCodeMatchedCount: 0,
    flag: 'Privilege',
  },
  {
    documentId: 109,
    reviewJobSubmittedId: 505,
    docId: 10009,
    issueCodeMatchedCount: 7,
    flag: '',
  },
  {
    documentId: 110,
    reviewJobSubmittedId: 505,
    docId: 10010,
    issueCodeMatchedCount: 4,
    flag: 'Priority',
  },
  {
    documentId: 111,
    reviewJobSubmittedId: 506,
    docId: 10011,
    issueCodeMatchedCount: 9,
    flag: '',
  },
  {
    documentId: 112,
    reviewJobSubmittedId: 506,
    docId: 10012,
    issueCodeMatchedCount: 1,
    flag: 'Hot',
  },
];

const VIEW_BY_DOCS_SORT_KEYS: Record<
  string,
  keyof IAIReviewJobResultDocsListItem
> = {
  DocId: 'docId',
  docId: 'docId',
  Flag: 'flag',
  flag: 'flag',
  IssueCodeMatchedCount: 'issueCodeMatchedCount',
  issueCodeMatchedCount: 'issueCodeMatchedCount',
};

/**
 * Mock for POST …/{jobId}/issuecoding/doc-result/view-by-docs when BE is unavailable.
 * Applies sort / filter / page so UI pagination can be exercised locally.
 */
export const getMockAIReviewJobResultDocsList = (
  payload: IAIReviewJobResultDocsListPayload
): IAIReviewJobResultDocsListResponse => {
  let rows = [...mockViewByDocsRows];

  for (const filter of payload.columnFilter ?? []) {
    const value = String(filter.value ?? '')
      .trim()
      .toLowerCase();
    if (!value) continue;

    const key =
      VIEW_BY_DOCS_SORT_KEYS[filter.columnName] ??
      (filter.columnName as keyof IAIReviewJobResultDocsListItem);

    rows = rows.filter((row) =>
      String(row[key] ?? '')
        .toLowerCase()
        .includes(value)
    );
  }

  const sortKey = VIEW_BY_DOCS_SORT_KEYS[payload.sortingColumn] ?? 'docId';
  const direction = (payload.direction ?? 'ASC').toUpperCase();
  rows.sort((a, b) => {
    const left = a[sortKey];
    const right = b[sortKey];
    if (left === right) return 0;
    if (left == null) return 1;
    if (right == null) return -1;
    const cmp = left < right ? -1 : 1;
    return direction === 'DESC' ? -cmp : cmp;
  });

  const pageSize = Math.max(1, payload.displayLength || 10);
  const pageNumber = Math.max(1, payload.pageNumber || 1);
  const start = (pageNumber - 1) * pageSize;

  return {
    totalDocCount: rows.length,
    totalIssuCodeCount: rows.reduce(
      (sum, row) => sum + (row.issueCodeMatchedCount || 0),
      0
    ),
    result: rows.slice(start, start + pageSize),
  };
};
